frontApp.dialog = {
  name: 'dialog',
  description: 'dialog',
  init() {
    Fancybox.bind('.js-dialog-inline', {
      mainClass: 'dialog-theme',
      type: 'inline',
      dragToClose: false,
    });
  },
};
